<template>
  <div class="rtp-panel">
    <div v-if="pageLoading" class="rtp-loading">
      <van-loading type="spinner" color="#8131e7" />
    </div>

    <template v-else>
      <!-- Reseller ID 模块 -->
      <div class="rtp-reseller-card">
        <p class="rtp-reseller-label">{{ $t("guild_transfer_to_reseller_label") }}</p>
        <div class="rtp-id-input-wrap">
          <input
            v-model="resellerId"
            type="text"
            inputmode="numeric"
            class="rtp-id-input"
            :placeholder="$t('guild_please_enter_reseller_uid')"
            @keyup.enter="searchReseller"
            @input="handleInput"
            @blur="searchReseller"
          />
          <button
            type="button"
            :class="['rtp-search-btn', resellerId.length > 0 ? 'act-rtp-search-btn' : '']"
            @click="searchReseller"
          ></button>
        </div>

        <div v-if="resellerList.length > 0" class="rtp-user-list">
          <div
            v-for="item in resellerList"
            :key="item.userId"
            class="rtp-user-item"
            :class="{ active: isSelected(item) }"
            @click="changeResellerId(item)"
          >
            <img class="rtp-avatar" :src="item.headIcon" alt="" />
            <div class="rtp-user-meta">
              <p class="rtp-user-name">{{ item.nickname }}</p>
              <p v-if="item.resellerFlag == 1" class="rtp-user-badge rtp-user-badge--ok">
                {{ $t("guild_amount_refunded") }}
              </p>
              <p v-else class="rtp-user-badge rtp-user-badge--no">
                {{ $t("guild_status_pending") }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 转移金额 -->
      <div class="rtp-main">
        <div class="rtp-body">
          <p class="rtp-section-title">{{ $t("guild_settlement_input_amount") }}</p>

          <div class="rtp-input-wrap" @click="inputFocus">
            <img class="rtp-coin" src="../../assets/withdrawal_v2/$.png" alt="" />
            <span ref="measureRef" class="rtp-measure" aria-hidden="true">{{ inputValue }}</span>
            <input
              ref="inputRef"
              v-model="inputValue"
              type="text"
              inputmode="numeric"
              class="rtp-input"
              :placeholder="$t('guild_please_enter')"
              @input="changeCoin"
              @click.stop="inputFocus"
              @blur="onInputBlur"
            />
          </div>

          <p class="rtp-balance">
            {{ $t("guild_current_can_withdraw") }}
            <img src="../../assets/withdrawal_v2/$.png" alt="" />
            <span>{{ coinText }}</span>
          </p>

          <ul class="rtp-gear-box">
            <li :class="{ active: gearType === 0 }" @click="changeGearType(0)">{{ $t("guild_all") }}</li>
            <li :class="{ active: gearType === 1 }" @click="changeGearType(1)">1/2</li>
            <li :class="{ active: gearType === 2 }" @click="changeGearType(2)">1/3</li>
            <li :class="{ active: gearType === 3 }" @click="changeGearType(3)">1/4</li>
          </ul>
        </div>

        <div class="rtp-footer">
          <button type="button" class="rtp-submit" @click="confirmBtn">
            {{ $t("withdraw_submit") }}
          </button>
        </div>
      </div>
    </template>

    <transfer-confirm-dialog
      :visible="showPop"
      :amount="displayAmount"
      desc-key="guild_reseller_confirm_desc"
      :tips="confirmTips"
      @close="closePopup"
      @confirm="confirm"
    />

    <div v-if="actionLoading" class="rtp-action-loading">
      <van-loading type="spinner" color="#8131e7" />
    </div>
    <!-- 需真人认证时展示认证弹窗；关闭按钮触发 close -->
    <certification-pop
      v-if="showCertification"
      :err-code="certErrCode"
      page-source="转reseller"
      @close="showCertification = false"
    ></certification-pop>
    <!-- 转移成功弹窗：样式与自提现一致，文案保持 reseller 现在的说明 -->
    <withdraw-success-modal
      :visible="showSuccess"
      tip-key="guild_reseller_tips"
      @confirm="onResellerSuccessConfirm"
    ></withdraw-success-modal>
  </div>
</template>

<script>
/**
 * 转移给 Reseller v2 主面板（2026-06-08）
 * Reseller 搜索交互沿用旧版；金额输入同自提现自定义（无法币）
 */
import axios from "axios";
import { Toast, Loading, Dialog } from "vant";
import "vant/lib/loading/style";
import TransferConfirmDialog from "@/components/withdrawal/transfer-confirm-dialog.vue";
import CertificationPop from "@/components/withdrawal/certification_pop.vue";
import WithdrawSuccessModal from "@/components/withdrawal/withdraw-success-modal.vue";

export default {
  name: "reseller-transfer-panel",
  components: {
    TransferConfirmDialog,
    CertificationPop,
    WithdrawSuccessModal,
    [Loading.name]: Loading,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      pageLoading: true,
      actionLoading: false,
      /** 是否展示真人认证弹窗（transfertoReseller/apply 返回 501915 时置 true） */
      showCertification: false,
      /** 触发认证弹窗的接口错误码（501915 / 501918），传给弹窗以区分 App 方法 */
      certErrCode: 0,
      /** 是否展示成功弹窗（与自提现一致） */
      showSuccess: false,
      resellerId: "",
      selectedUserId: null,
      toResellerId: "",
      resellerList: [],
      inputValue: "",
      gearType: 5,
      diamondNum: 0,
      currentCoin: 0,
      convertPer: 0,
      applyMinNum: 0,
      guildId: "",
      guildUid: "",
      showPop: false,
      token: "",
      uid: "",
      lang: "",
      deviceId: "",
    };
  },
  computed: {
    // 可转出余额的千分位展示文本
    coinText() {
      return Number(this.currentCoin || 0).toLocaleString("en-US");
    },
    // 输入框当前显示金额（经千分位格式化）
    displayAmount() {
      return this.formatInputValue(String(this.getInputNumber()));
    },
    // 确认弹窗提示文案列表（含最小转出金额参数）
    confirmTips() {
      return [
        { key: "guild_reseller_confirm_tip_1" },
        { key: "guild_reseller_confirm_tip_2" },
        { key: "guild_reseller_confirm_tip_3", params: { n: this.applyMinNum } },
      ];
    },
  },
  // 初始化：从路由参数读取公会信息/最小金额，鉴权并拉取 Reseller 信息
  created() {
    this.guildId = this.$route.query.guildId || "";
    this.guildUid = this.$route.query.guildUid || "";
    this.applyMinNum = Number(this.$route.query.minCoin || 0);
    this.initAuth();
    this.initResellerInfo();
  },
  methods: {
    // 从本地缓存初始化鉴权信息（token/uid/lang/deviceId）
    initAuth() {
      const raw = localStorage.getItem("data");
      if (!raw) {
        this.pageLoading = false;
        return;
      }
      try {
        const data = JSON.parse(raw);
        this.token = data.token;
        this.uid = String(data.uid ?? data.userId ?? "");
        this.lang = data.lang || navigator.language;
        this.deviceId = data.deviceId || "";
      } catch (e) {
        /* ignore */
      }
    },
    // 千分位格式化展示金额
    formatInputValue(raw) {
      if (!raw) return "";
      return Number(raw).toLocaleString("en-US");
    },
    // 去掉千分位逗号取实际数值
    getInputNumber() {
      return Number(String(this.inputValue).replace(/,/g, "")) || 0;
    },
    // 由金币数换算钻石数（向下取整）
    syncDiamondNum() {
      const coinNum = this.getInputNumber();
      this.diamondNum = Math.floor(coinNum / (this.convertPer || 1));
    },
    // Reseller ID 只保留数字；清空时重置选择状态
    handleInput() {
      this.resellerId = this.resellerId.replace(/[^\d]/g, "");
      if (!this.resellerId) {
        this.resellerList = [];
        this.selectedUserId = null;
        this.toResellerId = "";
      }
    },
    // 判断列表项是否处于选中态
    isSelected(item) {
      return this.selectedUserId === item.userId;
    },
    // 点击列表项：切换选中 / 取消选中
    changeResellerId(item) {
      if (this.selectedUserId === item.userId) {
        this.selectedUserId = null;
        this.resellerId = "";
        this.toResellerId = "";
      } else {
        this.selectedUserId = item.userId;
        this.resellerId = String(item.prettyNumber || item.userId);
        this.toResellerId = item.userId;
      }
    },
    // 按 uid 搜索 Reseller 用户列表
    searchReseller() {
      if (!this.resellerId) return;
      this.actionLoading = true;
      axios
        .get(
          `${this.$serviceIp}api/code/family/searchForRetrievePwd?uid=${this.resellerId}`,
          {
            headers: {
              deviceId: this.deviceId,
              version: "3.0",
              lang: this.lang,
            },
          }
        )
        .then(({ data }) => {
          if (data.code === 200) {
            // checkResult===1 表示用户不存在
            if (data.data.checkResult === 1) {
              Toast(this.$t("guild_user_not"));
              this.resellerList = [];
            } else {
              this.resellerList = data.data.personList || [];
              // 优先按 prettyNumber 精确匹配，其次按 userId
              let matchedItem = this.resellerList.find(
                (item) => item.prettyNumber && item.prettyNumber == this.resellerId
              );
              if (!matchedItem) {
                matchedItem = this.resellerList.find(
                  (item) => item.userId == this.resellerId
                );
              }
              if (matchedItem) {
                this.selectedUserId = matchedItem.userId;
                this.toResellerId = matchedItem.userId;
              }
            }
          } else {
            Toast(data.message || this.$t("transfer.error"));
          }
        })
        .catch(() => Toast(this.$t("transfer.error")))
        .finally(() => {
          this.actionLoading = false;
        });
    },
    // 初始化 Reseller 转账信息：汇率、当前金币、最小申请金额
    initResellerInfo() {
      if (!this.token || !this.uid) {
        this.pageLoading = false;
        return;
      }
      this.pageLoading = true;
      axios
        .get(
          `${this.$serviceIp}api/trade/guild/withdraw/reseller/init?token=${this.token}&uid=${this.uid}`,
          {
            headers: {
              deviceId: this.deviceId,
              version: "3.0",
              lang: this.lang,
            },
          }
        )
        .then(({ data }) => {
          if (data.code === 200) {
            // 汇率换算：接口返回的 convertPer 除以 10000
            this.convertPer = data.data.convertPer / 10000;
            this.currentCoin = data.data.currentCoin;
            // 路由参数未传最小金额时用接口值兜底
            if (!this.applyMinNum && data.data.applyMinNum) {
              this.applyMinNum = data.data.applyMinNum;
            }
          } else {
            Toast(data.message || this.$t("transfer.error"));
          }
        })
        .catch(() => Toast(this.$t("transfer.error")))
        .finally(() => {
          this.pageLoading = false;
        });
    },
    // 金额输入框聚焦：光标移到末尾，档位重置为自定义
    inputFocus() {
      const input = this.$refs.inputRef;
      if (!input) return;
      this.$nextTick(() => {
        input.focus();
        const len = input.value.length;
        input.setSelectionRange(len, len);
      });
      if (this.gearType !== 5) {
        this.gearType = 5;
      }
    },
    // 失焦处理（保持内容为空）
    onInputBlur() {
      if (this.inputValue === "") {
        this.inputValue = "";
      }
    },
    // 输入金额：清洗非法字符、千分位格式化，并按文本长度自适应输入框宽度
    changeCoin() {
      const raw =
        this.inputValue.toString().replace(/[^\d]/g, "").replace(/^0+/, "") || "";
      this.inputValue = this.formatInputValue(raw);
      this.syncDiamondNum();
      this.$nextTick(() => {
        const span = this.$refs.measureRef;
        const input = this.$refs.inputRef;
        if (!span || !input) return;
        let width = span.offsetWidth + 20;
        if (raw.length > 5) width += 20;
        if (raw.length > 9) width += 20;
        if (raw.length > 13) width += 20;
        input.style.width = `${Math.max(width, 40)}px`;
        const len = this.inputValue.length;
        input.setSelectionRange(len, len);
      });
    },
    // 快捷档位：全部 / 1/2 / 1/3 / 1/4，再次点击无反应（不取消选择）
    changeGearType(type) {
      this.gearType = type;
      const coin = Number(this.currentCoin || 0);
      if (type === 0) {
        this.inputValue = this.formatInputValue(String(coin));
      } else if (type === 1) {
        this.inputValue = this.formatInputValue(String(Math.floor(coin / 2)));
      } else if (type === 2) {
        this.inputValue = this.formatInputValue(String(Math.floor(coin / 3)));
      } else if (type === 3) {
        this.inputValue = this.formatInputValue(String(Math.floor(coin / 4)));
      }
      this.syncDiamondNum();
      this.changeCoin();
    },
    // 提交前校验：目标存在性 / 金额有效性 / 余额充足 / 不低于最小申请额
    confirmBtn() {
      if (!this.resellerId) {
        Toast(this.$t("guild_please_enter_reseller_uid"));
        return;
      }
      if (!this.resellerList.length) {
        Toast(this.$t("guild_please_search_reseller_first"));
        return;
      }
      // 确认当前输入在搜索结果中（防止伪造 uid）
      const isValidReseller = this.resellerList.some(
        (item) =>
          item.userId == this.resellerId || item.prettyNumber == this.resellerId
      );
      if (!isValidReseller) {
        Toast(this.$t("guild_please_search_reseller_first"));
        return;
      }
      const amount = this.getInputNumber();
      if (!amount) {
        Toast(this.$t("guild_please_enter_amount"));
        return;
      }
      // 余额不足
      if (amount > Number(this.currentCoin)) {
        Toast(this.$t("guild_insufficient_balance"));
        return;
      }
      // 低于最小申请金额
      if (amount < Number(this.applyMinNum)) {
        Toast(this.$t("guild_tips_1") + this.applyMinNum);
        return;
      }
      this.syncDiamondNum();
      // 校验通过后弹出确认弹窗
      this.showPop = true;
    },
    // 关闭确认弹窗
    closePopup() {
      this.showPop = false;
    },
    // 确认转账：调用 transfertoReseller/apply 接口
    confirm() {
      this.closePopup();
      this.actionLoading = true;
      const coinNum = this.getInputNumber();
      axios({
        url: `${this.$serviceIp}api/trade/guild/withdraw/transfertoReseller/apply`,
        method: "post",
        headers: {
          version: "3.0",
          deviceId: this.deviceId,
          lang: this.lang,
        },
        data: {
          guildId: this.guildId,
          resellerId: this.toResellerId,
          coinNum,
          diamondNum: this.diamondNum,
        },
        params: { token: this.token, uid: this.uid },
      })
        .then((res) => {
          if (res.data.code === 200) {
            // 成功：展示与自提现一致的成功弹窗
            this.showSuccess = true;
            // 501912 , 501918, 501923  都归为 性别认证失败场景,需性别认证
            // 501915 需真人认证拦截
          } else if (res.data.code === 501915 || res.data.code === 501918 || res.data.code === 501912 || res.data.code === 501923) {
            // 需真人认证：展示认证弹窗（记录错误码供弹窗区分 App 方法）
            this.certErrCode = res.data.code;
            this.showCertification = true;
          } else {
            Toast(res.data.message || this.$t("transfer.error"));
          }
        })
        .catch(() => Toast(this.$t("transfer.error")))
        .finally(() => {
          this.actionLoading = false;
        });
    },
    // 成功弹窗「知道了」：关闭弹窗并返回上一页（保持原来功能）
    onResellerSuccessConfirm() {
      this.showSuccess = false;
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.rtp-panel {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding-top: 20px;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
}

.rtp-loading {
  display: flex;
  justify-content: center;
  padding: 80px 0;
}

.rtp-reseller-card {
  flex-shrink: 0;
  width: calc(100% - 56px);
  max-width: 594px;
  margin: 0 auto 24px;
  padding: 24px;
  background: #fff;
  border-radius: 24px;
  box-sizing: border-box;
}

.rtp-reseller-label {
  margin: 0 0 16px;
  font-size: 24px;
  font-weight: 400;
  color: #89848d;
  text-transform: uppercase;
  text-align: center;
}

.rtp-id-input-wrap {
  position: relative;
}

.rtp-id-input {
  width: 100%;
  height: 88px;
  padding: 0 100px 0 24px;
  border: 1px solid #dbdbdb;
  border-radius: 24px;
  font-size: 28px;
  font-weight: 500;
  color: #262427;
  box-sizing: border-box;
  background: #fff;
  display: block;
}

.rtp-id-input::placeholder {
  color: #c4c0c8;
  font-weight: 400;
}

.rtp-search-btn {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  width: 80px;
  height: 56px;
  border: none;
  border-radius: 28px;
  background: #DFD9E3 url("../../assets/withdrawal_v2/search.png") no-repeat center;
  background-size: 32px 32px;
  cursor: pointer;
}
.act-rtp-search-btn{
  background: #8131E7 url("../../assets/withdrawal_v2/search2.png") no-repeat center;
  background-size: 32px 32px;

}

.rtp-user-list {
  margin-top: 24px;
  /* padding-top: 20px; */
  /* border-top: 1px solid #f1f1f1; */
}

.rtp-user-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  border-radius: 16px;
  cursor: pointer;
}

.rtp-user-item.active {
  /* background: rgba(129, 49, 231, 0.08); */
}

.rtp-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.rtp-user-meta {
  flex: 1;
  min-width: 0;
}

.rtp-user-name {
  margin: 0 0 8px;
  font-size: 28px;
  font-weight: 600;
  color: #262427;
}

.rtp-user-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 24px;
  font-weight: 500;
}

.rtp-user-badge--ok {
  color: #28c256;
}

.rtp-user-badge--ok::before {
  content: "";
  width: 28px;
  height: 28px;
  background: url("../../assets/withdrawal/reseller-yes.png") no-repeat center;
  background-size: contain;
}

.rtp-user-badge--no {
  color: #ff4343;
}

.rtp-user-badge--no::before {
  content: "";
  width: 28px;
  height: 28px;
  background: url("../../assets/withdrawal/reseller-not.png") no-repeat center;
  background-size: contain;
}

.rtp-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border-radius: 24px 24px 0 0;
  padding: 24px 32px calc(16px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  overflow: hidden;
}

.rtp-body {
  flex: 1;
  min-height: 0;
}

.rtp-section-title {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 400;
  color: #89848d;
}

.rtp-input-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 80px;
  padding: 0 24px;
  border: 1px solid #DFD9E3;
  border-radius: 16px;
  background: #fff;
  box-sizing: border-box;
}

.rtp-coin {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.rtp-measure {
  position: absolute;
  visibility: hidden;
  white-space: pre;
  font-size: 28px;
  font-family: "Mada", sans-serif;
  top: -9999px;
  left: -9999px;
}

.rtp-input {
  flex: 1;
  min-width: 40px;
  border: none;
  outline: none;
  background: transparent;
  font-size: 28px;
  font-weight: 700;
  color: #262427;
}

.rtp-input::placeholder {
  color: #c4c0c8;
  font-weight: 400;
}

.rtp-balance {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 26px 0 10px;
  font-size: 24px;
  font-weight: 400;
  color: #262427;
}

.rtp-balance img {
  width: 36px;
  height: 36px;
}

.rtp-balance span {
  /* font-weight: 700; */
}

.rtp-gear-box {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.rtp-gear-box li {
  height: 64px;
  border: 1px solid #DFD9E3;
  border-radius: 32px;
  font-size: 24px;
  font-weight: 500;
  line-height: 64px;
  color: #DFD9E3;
  text-align: center;
  padding: 0 46px;
}

.rtp-gear-box li.active {
  color: #8131e7;
  border-color: #8131e7;
}

.rtp-footer {
  flex-shrink: 0;
  margin-top: auto;
  padding-top: 48px;
  display: flex;
  justify-content: center;
}

.rtp-submit {
  width: 100%;
  max-width: 412px;
  height: 80px;
  border: none;
  border-radius: 40px;
  background: #8131e7;
  font-size: 24px;
  font-weight: 500;
  color: #fff;
}

.rtp-action-loading {
  position: fixed;
  inset: 0;
  z-index: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.4);
}

html[lang="ar"] .rtp-panel,
html[lang="ar"] .rtp-main {
  direction: rtl;
}

html[lang="ar"] .rtp-id-input {
  padding: 0 24px 0 100px;
}

html[lang="ar"] .rtp-search-btn {
  right: auto;
  left: 16px;
}
</style>
